import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  id: "citesModal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "textpage" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Washingtoner Artenschutzübereinkommen"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode(" In einigen Flöten verbaue ich "),
      /*#__PURE__*/_createElementVNode("i", null, "legal erworbene"),
      /*#__PURE__*/_createTextVNode(" Hölzer, die dem Washingtoner Artenschutzübereinkommen unterligen (Convention on International Trade in Endangered Species of Wild Fauna and Flora, kurz CITES). Sollten Sie eine solche Flöte erweben wollen ... ")
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalTitleComponent = _resolveComponent("ModalTitleComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalTitleComponent, { title: "CITES" }),
        _hoisted_4
      ])
    ])
  ]))
}